import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { api, formatApiError } from "@/lib/api";
import { SITE } from "@/lib/site";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink px-5">
      <Seo title="Owner login" description="Alpha Transfer owner dashboard login." noindex />
      <form onSubmit={submit} className="card-soft w-full max-w-md bg-white p-8 md:p-10" data-testid="admin-login-form">
        <img src={SITE.logoDark} alt="Alpha Transfer logo" className="h-10 w-auto" />
        <h1 className="mt-8 font-serif text-3xl text-ink">Owner dashboard</h1>
        <p className="mt-2 text-sm text-slate-500">Sign in to manage bookings, prices and inquiries.</p>
        <div className="mt-8 space-y-5">
          <div>
            <label className="field-label" htmlFor="admin-email">Email</label>
            <input id="admin-email" type="email" autoComplete="username" className="field-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" required />
          </div>
          <div>
            <label className="field-label" htmlFor="admin-password">Password</label>
            <input id="admin-password" type="password" autoComplete="current-password" className="field-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" required />
          </div>
          {error && <p className="field-error" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={busy} className="btn btn-dark w-full" data-testid="admin-login-submit">{busy ? "Signing in…" : "Sign in"}</button>
        </div>
      </form>
    </div>
  );
}
